<template>
  <div
    v-if="value || editable"
    class="purchases__form-block"
  >
    <div class="row">
      <div class="col-12 col-lg-4">
        <label class="purchases__form-label">{{ title }}</label>
      </div>
      <div
        class="col-12 col-lg-8 purchases__form-value"
      >
        <div
          v-if="!editMode"
          v-html="value || '<i>Не указан</i>'"
        />
        <ButtonForm
          v-if="editable && !editMode"
          :label="!saving ? 'Изменить' : 'Сохранение...'"
          :disabled="saving"
          style="margin-left: 20px;padding: 2px 10px;"
          @click="editMode = true"
        />
        <InputForm
          v-if="editable && editMode && !saving"
          v-model:value="newValue"
          input-class="purchases__form-input purchases__form-input--blue"
          :value="value"
          type="phone"
          style="width: 100%"
        />
        <ButtonForm
          v-if="editable && editMode && !saving"
          style="margin-left: 20px;padding: 2px 10px;"
          label="Сохранить"
          @click="saveValue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import InputForm from '@/components/form/input-form.vue';
import ButtonForm from '@/components/form/button-form.vue';
import th from 'air-datepicker/locale/th';

export default {
  name: 'DetailsSectionCommon',
  components: { ButtonForm, InputForm },
  props: {
    data: Object,
    role: String,
    saving: Boolean,
    editable: Boolean,
  },
  emits: ['edit-callback'],
  data() {
    return {
      editMode: false,
      newValue: undefined,
    };
  },
  computed: {
    title() {
      return this.data.title;
    },
    value() {
      if (this.newValue) return this.newValue;
      if (this.data.type === 'date') {
        return dayjs(this.data.value).format('DD.MM.YYYY');
      }
      if (this.data.type === 'dateTime') {
        return dayjs(this.data.value).format('DD.MM.YYYY HH:mm Z');
      }
      if (this.data.value) {
        return this.data.value;
      }
      if (Array.isArray(this.data.values)) {
        return (this.data.values.find((value) => value.selected) || {}).title;
      }
      return '';
    },
    type() {
      return this.data.type;
    },
  },
  mounted() {
    this.newValue = this.value;
  },
  methods: {
    enableEdit() {
      this.editMode = true;
    },
    saveValue() {
      this.$emit('edit-callback', this.newValue);
      this.editMode = false;
      this.value = this.newValue;
    },
  },
};
</script>
